import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import type { AuthTokens, User } from '@sss/types';
import { api } from '../lib/api';
import { setSession } from '../store/authSlice';

// The login-step token is kept in sessionStorage rather than the URL so it
// doesn't land in browser history, Referer headers, or server logs.
const VERIFY_MFA_KEY = 'sss.verifyMfaToken';

export function stashVerifyMfaToken(token: string): void {
  sessionStorage.setItem(VERIFY_MFA_KEY, token);
}

export default function VerifyMfaPage() {
  const [verifyMfaToken] = useState(() => sessionStorage.getItem(VERIFY_MFA_KEY));
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      const result = await api<{ user: User; tokens: AuthTokens }>('/v1/auth/verify-mfa', {
        method: 'POST',
        auth: false,
        body: JSON.stringify({ verifyMfaToken, mfaToken: code }),
      });
      sessionStorage.removeItem(VERIFY_MFA_KEY);
      dispatch(
        setSession({
          user: result.user,
          accessToken: result.tokens.access.token,
          refreshToken: result.tokens.refresh.token,
        }),
      );
      navigate('/account');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Verification failed');
    }
  }

  return (
    <main style={{ maxWidth: 360, margin: '4rem auto', fontFamily: 'system-ui, sans-serif' }}>
      <h1>Two-factor code</h1>
      <form onSubmit={onSubmit}>
        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="123456"
        />
        <button type="submit">Verify</button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </main>
  );
}
